import { Button, Typography, Box } from '@mui/material'
import React from 'react'
import LoadingSpinner from './LoadingSpinner'

export default function BasicButtom({ onClick, loading }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>

            <Button
                onClick={onClick}
                disabled={loading}
                sx={{
                    width: '270px',
                    height: '50px',
                    bgcolor: '#20BC71',
                    color: '#000',
                    borderRadius: 999,
                    mr: '20px',
                    "&:hover": {
                        bgcolor: "#000",
                        boxShadow: "none",
                        color: '#fff'
                    },
                    "&:disabled": {
                        opacity: 0.7,
                        cursor: "not-allowed"
                    }
                }}>
                <Typography variant='text'>
                    Download
                </Typography>
            </Button>
            {loading && <LoadingSpinner />}

        </Box>
    )
}
